import o from"../core/colors/index.js";var p={sizes:{XXS:"32px",XS:"48px",S:"56px",M:"68px",L:"80px",XL:"92px"},defaultColor:o.blue[500]};export{p as default};
